import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 28,
    padding: '6px 12px',
    borderRadius: 8,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
  },
  active: {
    background: '#e8f2cc',
    border: '1px solid #c8d89d',
    color: '#688424',
  },
  inactive: {
    background: '#eee8df',
    border: '1px solid #d8cec1',
    color: '#7b6d61',
  },
}));

interface PublicationStatusBadgeProps {
  publicationStateId?: string | number;
  status?: string;
}

const getStatusLabel = (publicationStateId?: string | number, status?: string) => {
  const stateId = String(publicationStateId ?? '');

  if (stateId === '1') return 'Activa';
  if (stateId === '2') return 'Inactiva';

  const normalizedStatus = status?.toLowerCase() || '';
  if (normalizedStatus === 'activa' || normalizedStatus === 'active') return 'Activa';
  if (normalizedStatus === 'inactiva' || normalizedStatus === 'inactive') return 'Inactiva';

  return status || 'N/A';
};

const isActivePublication = (publicationStateId?: string | number, label?: string) => {
  const stateId = String(publicationStateId ?? '');
  if (stateId === '1') return true;
  if (stateId === '2') return false;
  return label?.toLowerCase() === 'activa';
};

export const PublicationStatusBadge = ({
  publicationStateId,
  status,
}: PublicationStatusBadgeProps) => {
  const classes = useStyles();
  const label = getStatusLabel(publicationStateId, status);
  const isActive = isActivePublication(publicationStateId, label);

  return (
    <span className={`${classes.badge} ${isActive ? classes.active : classes.inactive}`}>
      {label}
    </span>
  );
};
